import { styled } from '@mui/material/styles';
import TripOriginIcon from '@mui/icons-material/TripOrigin';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import type { StepIconProps } from '@mui/material/StepIcon';

interface StepIconRootProps {
	ownerState: {
		active?: boolean;
		completed?: boolean;
	};
}

const StepIconRoot = styled('div', {
	shouldForwardProp: (prop) => prop !== 'ownerState',
})<StepIconRootProps>(({ theme, ownerState }) => ({
	color: ownerState.active || ownerState.completed ? theme.palette.brand.main : theme.palette.grey[400],
	display: 'flex',
	height: 22,
	alignItems: 'center',
	...theme.applyStyles('dark', {
		color: theme.palette.grey[700],
	}),
}));

export const CustomStepIcon = (props: StepIconProps) => {
	const { active, completed, className } = props;

	return (
		<StepIconRoot ownerState={{ active, completed }} className={className}>
			{completed ? (
				<CheckCircleIcon sx={{ fontSize: 36, color: 'currentColor' }} />
			) : (
				<TripOriginIcon sx={{ fontSize: 36, color: 'currentColor' }} />
			)}
		</StepIconRoot>
	);
};
